export const MALEK_CART_ITEMS_KEY = "malekstore_cart_items";
export const MALEK_STORE_TOKEN_KEY = "mk_store_tk";
export const MALEK_USERNAME_KEY = "mk_store_username";
export const MALEK_WISHLIST_KEY = 'mk_store_wishlist';